




import { Component, Vue } from "vue-property-decorator";
import ReservationsTable from "@/components/ReservationsTable.vue";
import GlobalFilterSensitiveMixin from '@/mixins/GlobalFilterSensitiveMixin';
import { NavigationGuardNext, Route } from "vue-router/types/router";
import { Action, Getter } from "vuex-class";
import { join } from "lodash";

@Component({
  components: {
    ReservationsTable
  },
  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext) {
    if (to.name === "Reservations") {
      next();
    } else {
      const fresh = to.query.customerId;
      const role = to.query.customerRole ? to.query.customerRole.toString() : null;
      Vue.axios
        .get(`customers/${fresh}`)
        .then(({ data }) => {
          next(
            // prettier-ignore
            (vm: Vue) => {
              const that = vm as Reservations;
              let roleName = "";
               switch (role) {
                case null:
                  roleName = "Customers.AllRoles";
                  break;
                case "1":
                  roleName = "Customers.ReservationHolder";
                  break;
                case "2":
                  roleName = "Customers.Guest";
                  break;
                case "3":
                  roleName = "Customers.Owner";
                  break;
                default:
                  roleName = "";
                  break;
              }
              const customerName = join([
                that.$t("Customers.Reservations").toString(),
                data.firstName, 
                data.lastName,
                "-",
                that.$t(roleName).toString()], " ");
              that.breadcrumbs = [customerName];
              that.setCustomBreadcrumbs && that.setCustomBreadcrumbs(that.breadcrumbs);
            }
          );
        })
        .catch(() => next({ name: "Reservations", replace: true }));
    }
  },
  mixins: [
    GlobalFilterSensitiveMixin
  ]
})
export default class Reservations extends Vue {
  @Action("setCustomBreadcrumbs") setCustomBreadcrumbs?: (
    payload: string[] | undefined
  ) => Promise<void>;
  @Getter("customBreadcrumbs") customBreadcrumbs?: string[];

  async destroyed() {
    if (this.customBreadcrumbs == this.breadcrumbs) {
      this.setCustomBreadcrumbs && this.setCustomBreadcrumbs(undefined);
    }
  }

  breadcrumbs: string[] = [];
}
